class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.refresh) {
      return user.refresh;
    }
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.refresh) {
      return user.access;
    }
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.access = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  removeUser() {
    localStorage.removeItem("user");
  }

  setRegisterUser(user) {
    localStorage.setItem("registerUser", JSON.stringify(user));
  }

  getRegisterUser() {
    return JSON.parse(localStorage.getItem("registerUser"));
  }

  removeRegisterUser(user) {
    localStorage.removeItem("registerUser");
  }
}

export default new TokenService();
